<template>
  <div id="top-header">
    <div class="header-right-decoration flex-box">
      <div @click="onClick" class="pointer active">【显示菜单】</div>
    </div>
    <div class="header-center-decoration"></div>
    <div class="header-left-decoration flex-box end flex-row"></div>
    <div class="center-title">{{ $matrix.Config.Title }}</div>
  </div>
</template>

<script>
export default {
  name: 'TopHeader',
  props: {
    value: Object,
    config: Object
  },

  data() {
    return {
      isFull: true
    }
  },
  methods: {
    onClick() {
      this.isFull = !this.isFull
      console.log(this.isFull)
      this.$emit('event', this.isFull)
    }
  },
 
}
</script>

 
